@let m = mark();
@if (m.kind === 'image') {
  <div class="flex-center-column flex-gap-1">
    <img [src]="m.url" class="logo" alt="Logo" />
    @if (showsBrandName) {
      <span class="brand-name">{{ appName() }}</span>
    }
  </div>
} @else if (m.kind === 'text') {
  <div class="flex-center">
    <span class="brand-wordmark">{{ m.label }}</span>
  </div>
} @else if (m.kind === 'tefter') {
  <div class="tefter-logo flex-center-column" [class.tefter-logo--compact]="compact">
    <svg
      [attr.width]="svgWidth"
      [attr.height]="svgHeight"
      viewBox="0 0 100 60"
      aria-hidden="true"
      style="display: block"
    >
      <circle cx="32" cy="30" r="18" fill="none" stroke="#3D5FDB" stroke-width="11" />
      <circle cx="68" cy="30" r="18" fill="none" stroke="#3D5FDB" stroke-width="11" />
      <rect x="44" y="24.5" width="12" height="11" fill="#3D5FDB" />
      <rect x="46" y="26" width="8" height="8" fill="#fff" />
    </svg>

    <div class="tefter-logo__wordmark">TEFTER</div>

    @if (!compact) {
      <div class="tefter-logo__tagline">YOUR BUSINESS IN YOUR POCKET</div>
    }
  </div>
}
